<template>
  <div
    class="bg-white border-gray-300 text-gray-800 dark:border-dark-400 dark:bg-dark-800 dark:text-dark-text-dark"
    style="border-radius: 1rem"
  >
    <div class="w-full px-6 pt-3">
      <div class="ml-1 mb-1 flex">
        <span class="material-icons mr-1">code</span>
        <div class="my-auto">{{ $t('message.sourceCode') }} :</div>
      </div>
      <ReviewEditor :height="200" :isEditable="false" :value="entry.sourceCode" />
    </div>

    <div v-if="entry.compileError !== '' || entry.runtimeError !== ''" class="mx-6 mt-3">
      <div class="ml-1 mb-1 flex">
        <span class="material-icons mr-1">warning</span>
        <div class="my-auto">{{ $t('message.error') }} :</div>
      </div>
      <div
        class="border flex px-3 py-3 text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900"
        style="user-select: contain; border-radius: 0.5rem"
      >
        <div v-if="entry.compileError !== ''" class="w-full">
          {{ entry.compileError }}
        </div>
        <div v-if="entry.runtimeError !== ''" class="w-full">
          {{ entry.runtimeError }}
        </div>
      </div>
    </div>

    <div class="w-full px-6 pt-6 pb-6">
      <div class="ml-1 mb-1 flex">
        <span class="material-icons mr-1">edit_square</span>
        <div class="my-auto">{{ $t('message.reviewEditor') }} :</div>
      </div>
      <ReviewEditor
        :height="200"
        :isEditable="true"
        :onChange="setReview"
        :value="postReviewPresenter.reviewList.value[entry.entryId] ?? ''"
      />
    </div>
    <div class="flex items-center justify-center">
      <div class="text-center flex-grow mb-4">
        <IconTextButton
          :border_radius="2"
          :font_weight="'700'"
          :icon="'send'"
          :iconSize="'text-2xl'"
          :padding_bottom="4"
          :padding_left="12"
          :padding_right="12"
          :padding_top="4"
          :text="$t(`message.newReviewSubmit`)"
          :textSize="'text-base'"
          @click="clickPostReview()"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import ReviewEditor from './ReviewEditor.vue'

import IconTextButton from '@/presentation/components/Button/IconTextButton.vue'
import { useAuthStatePresenter } from '@/presentation/composables/auth/useAuthStatePresenter'
import { useNotificationPresenter } from '@/presentation/composables/notification/useNotificationPresenter'
import { useOpenReviewPostEntryPresenter } from '@/presentation/composables/reviewPost/useOpenReviewPostEntryPresenter'
import { usePostReviewPresenter } from '@/presentation/composables/reviewPost/usePostReviewPresenter'
import timestampToDate from '@/util/date/timestampToDate'

export default defineComponent({
  components: {
    ReviewEditor,
    IconTextButton
  },
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  setup(props, ctx) {
    const postReviewPresenter = usePostReviewPresenter()
    const openReviewPostEntryPresenter = useOpenReviewPostEntryPresenter()
    const { user } = useAuthStatePresenter()
    const notificationPresenter = useNotificationPresenter()

    const setReview = (message: string) => {
      postReviewPresenter.setReview(props.entry.entryId, message)
    }

    const clickPostReview = () => {
      postReviewPresenter.postReview(
        props.entry.entryId,
        postReviewPresenter.reviewList.value[props.entry.entryId],
        user.value.id
      )
      notificationPresenter.submitReviewNotification()
    }

    return {
      clickPostReview,
      timestampToDate,
      setReview,
      postReviewPresenter,
      openReviewPostEntryPresenter
    }
  }
})
</script>

<style lang="postcss" scoped>
.panel-top {
  padding: 0.7em 1em 0.7em 1em;
}

.panel-bottom {
  padding: 0em 0em 0em 0em;
}

.no-select {
  user-select: none;
}
</style>
